import { isOntologyGraphFeatureVisible } from '@/config/ontologyGraph';

const BASE_NAVIGATION_LINKS = [
  {
    label: 'Profile Area',
    href: '/Profile-area',
    cmsKey: 'navigation.profileArea',
    showOnlyMobile: true,
  },
  {
    label: 'About',
    href: '/about',
    cmsKey: 'navigation.about',
  },
  {
    label: 'Docs',
    href: '/docs',
    cmsKey: 'navigation.docs',
  },
  {
    label: 'Tools',
    href: '/Tools',
    cmsKey: 'navigation.tools',
  },
  {
    label: 'Pricing',
    href: '/plans',
    cmsKey: 'navigation.pricing',
  },
  {
    label: 'AIDA',
    href: '/Assistant',
    cmsKey: 'navigation.aida',
  },
  {
    label: 'Advanced Search',
    href: '/advancedSearch',
    cmsKey: 'navigation.advancedSearch',
  },
  {
    label: 'Enrichment',
    href: '/enrichment',
    cmsKey: 'navigation.enrichment',
  },
  ...(isOntologyGraphFeatureVisible
    ? [
        {
          label: 'Ontology Explorer',
          href: '/ontology-graph',
          cmsKey: 'navigation.diseaseExplorer',
        },
      ]
    : []),
];

export const NAVIGATION_LINKS = BASE_NAVIGATION_LINKS;
